import { render } from "./GiveFeedback.vue?vue&type=template&id=0c11798b&scoped=true"
import script from "./GiveFeedback.vue?vue&type=script&lang=ts"
export * from "./GiveFeedback.vue?vue&type=script&lang=ts"

import "./GiveFeedback.vue?vue&type=style&index=0&id=0c11798b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c11798b"

export default script